/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membersrequestedat2Inputs */

const en_membersrequestedat2 = /** @type {(inputs: Membersrequestedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Asked on ${i?.date}`)
};

const de_membersrequestedat2 = /** @type {(inputs: Membersrequestedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Angefragt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Asked on {date}" |
*
* @param {Membersrequestedat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersrequestedat2 = /** @type {((inputs: Membersrequestedat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersrequestedat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersrequestedat2(inputs)
	return de_membersrequestedat2(inputs)
});
export { membersrequestedat2 as "membersRequestedAt" }